import styled from "styled-components"

const StyledHelpPlanet = styled.section`
  .box-intro {
    padding: 116px 30px 600px;
    z-index: 1;
    .scroll-arrow {
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-52%, 48%);
      width: 104px;
      height: 104px;
      border-radius: 50%;
      background-color: #fff;
      svg {
        max-width: 32px;
      }
    }
    &__header {
      text-align: center;
      max-width: 484px;
      margin: 0 auto;
      .title {
        margin-top: 40px;
        /* color: #fff; */
      }
    }
  }
  .box-about {
    position: relative;
    z-index: 1;
    margin-bottom: 315px;
    &__inner {
      margin-top: -330px;
      border: 5px solid #000;
      padding-bottom: 100px;
    }
    &__description {
      position: relative;
      z-index: 3;
      max-width: 910px;
      padding: 65px 52px 57px 45px;
      margin: 0 auto 235px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      border: 5px solid #000;
      transform: translateY(-50%);
      .box-image {
        flex: 1;

        svg,
        img {
          max-height: 76px;
        }
      }
      .box-text {
        flex-basis: 485px;
        max-width: 485px;
      }
    }
    &__grid {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      text-align: center;
      .grid-item-divider {
        flex: 1;
        display: flex;
        justify-content: center;
        padding: 45px 0;
        svg {
          width: 100%;
          max-width: 31px;
        }
      }
      .grid-item {
        flex-basis: 274px;
        max-width: 274px;
        .box-image {
          min-height: 125px;
        }
        .title {
          text-transform: uppercase;
          line-height: 31px;
          margin-bottom: 10px;
        }
      }
    }
    .btn-more {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 50%);
      background-color: #fff;
      min-width: 284px;
    }
  }
  @media screen and (max-width: 1400px) {
    .box-intro {
      padding: 70px 30px 420px;
      .scroll-arrow {
        transform: translate(-50%, 50%);
        width: 74px;
        height: 74px;
        svg {
          max-width: 21px;
        }
      }
      &__header {
        max-width: 384px;
        .title {
          margin-top: 30px;
        }
      }
    }
    .box-about {
      margin-bottom: 190px;
      .main-container {
        padding: 0 8.5%;
      }
      &__inner {
        margin-top: -235px;
        border: 5px solid #000;
        padding: 0 25px 135px;
      }
      &__description {
        max-width: 858px;
        padding: 50px 108px 50px 65px;
        margin: 0 auto 102px;
        .box-image {
          svg {
            max-height: 55px;
          }
        }
        .box-text {
          flex-basis: 414px;
          max-width: 414px;
        }
      }
      &__grid {
        .grid-item-divider {
          padding: 40px 0;
          svg {
            max-width: 21px;
          }
        }
        .grid-item {
          flex-basis: 192px;
          max-width: 192px;
          .box-image {
            min-height: 110px;
            svg {
              max-width: 55px;
            }
          }
          .title {
            margin-bottom: 0px;
          }
        }
      }
      .btn-more {
        min-width: 250px;
      }
    }
  }
  @media screen and (max-width: 1100px) {
    .box-intro {
      padding-bottom: 450px;
    }
    .box-about {
      &__description {
        flex-flow: wrap;
        text-align: center;
        padding: 40px 30px;
        .box-image {
          flex-basis: 100%;
          max-width: 100%;
          margin-bottom: 30px;
        }
        .box-text {
          flex-basis: 100%;
          max-width: 100%;
        }
      }
      &__grid {
        flex-direction: column;
        align-items: center;
        .grid-item-divider {
          padding: 45px 0;
          svg {
            transform: rotate(90deg);
          }
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    .box-intro {
      padding: 60px 16px 550px;
      &__header {
        max-width: 342px;
        .title {
          font-size: 34px;
          line-height: 43px;
          margin-top: 30px;
        }
      }
    }
    .box-about {
      position: relative;
      z-index: 1;
      margin-bottom: 0px;
      .main-container {
        padding: 0;
      }
      &__inner {
        margin-top: -250px;
        padding: 0 16px 50px;
        border: none;
      }
      &__description {
        padding: 40px 24px;
        margin: 0 auto;
        .box-image {
          margin-bottom: 40px;
          svg {
            max-height: 50px;
          }
        }
        .box-text {
          p {
            line-height: 21px;
          }
        }
      }
      &__grid {
        .grid-item-divider {
          padding: 40px 0;
        }
        .grid-item {
          flex-basis: 100%;
          .box-image {
            svg {
              max-width: 40px;
              max-height: 65px;
            }
            min-height: 80px;
          }
        }
      }
      .btn-more {
        position: relative;
        left: 0;
        margin-top: 85px;
        min-width: 100%;
        transform: none;
      }
    }
  }
`

export default StyledHelpPlanet
